<section class="custom-report">
    <header class="custom-report__header">
        <p class="custom-report__title">Your report is ready to build</p>
        <p class="custom-report__subtitle">Select a data source first, then add filters and visuals to shape the report.</p>
    </header>

    <app-inbuilt-datasource [hasReportAdminRole]="hasReportAdminRole" [hasDataSource]="hasDataSource" [reportNameFromQueryParams]="reportNameFromQueryParams"
        #inbuiltDatasource (selectDataSource)="onSelectDataSource($event)"></app-inbuilt-datasource>

    <!-- <p class="custom-report__section-label">Available after source selection</p> -->

    <div class="custom-report__row">
        <app-inbuilt-filter class="custom-report__col" (addFilter)="onAddFilter()"></app-inbuilt-filter>
        <app-inbuilt-visual class="custom-report__col" [showVisualMenu]="showVisualMenu" [visualTypeOptions]="visualTypeOptions"
            (addVisual)="onAddVisual()" (visualTypeSelected)="onSelectVisualType($event)"></app-inbuilt-visual>
    </div>
</section>

<app-modal [maximizable]="false" [inViewport]="true" #requireDatasourceModal class="modal-demo require-datasource-popup"
    (closeModal)="onRequireDatasourceCancelled()">
    <ng-container class="app-modal-header">
        <div class="require-datasource-popup__heading">
            <span class="require-datasource-popup__title">{{ requireDatasourceModalRef.headerTitle }}</span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-require-datasource-modal #requireDatasourceModalRef [context]="requireDatasourceContext"
            (selectDataSource)="onRequireDatasourceSelect()" (cancelled)="onRequireDatasourceCancelled()">
        </app-require-datasource-modal>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #addFilterModal class="modal-demo add-filter-popup"
    (closeModal)="onAddFilterCancelled()">
    <ng-container class="app-modal-header">
        <div class="add-filter-popup__heading">
            <span class="add-filter-popup__title">Add filter</span>
            <span class="add-filter-popup__subtitle">Describe the filter you need and generate a ready-to-review configuration.</span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-add-filter-modal #addFilterModalBody [selectedDataSource]="dataSourceJson" (cancelled)="onAddFilterCancelled()"
            (filterCreated)="onFilterCreated($event)">
        </app-add-filter-modal>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="add-filter-popup__footer">
            <!-- <span class="add-filter-popup__note">The generated filter is not applied automatically</span> -->
            <div class="add-filter-popup__actions">
                <button type="button" class="add-filter-popup__btn add-filter-popup__btn--secondary"
                    (click)="addFilterModalBody.onCancel()">
                    Cancel
                </button>
                <button type="button" class="add-filter-popup__btn add-filter-popup__btn--primary"
                    [disabled]="!addFilterModalBody.canPerformPrimaryAction" (click)="addFilterModalBody.onPrimaryAction()">
                    {{ addFilterModalBody.primaryActionLabel }}
                </button>
            </div>
        </div>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #addVisualModal class="modal-demo add-visual-popup"
    (closeModal)="onAddVisualCancelled()">
    <ng-container class="app-modal-header">
        <div class="add-visual-popup__heading">
            <span class="add-visual-popup__title">{{ addVisualModalBody.modalTitle }}</span>
            <span class="add-visual-popup__subtitle">Describe the visual you need and generate a ready-to-review configuration.</span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-add-visual-modal #addVisualModalBody [visualTypeLabel]="selectedVisualMenuItem?.label || ''"
            (cancelled)="onAddVisualCancelled()" (visualCreated)="onVisualCreated($event)">
        </app-add-visual-modal>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="add-visual-popup__footer">
            <div class="add-visual-popup__actions">
                <button type="button" class="add-visual-popup__btn add-visual-popup__btn--secondary"
                    (click)="addVisualModalBody.onCancel()">
                    Cancel
                </button>
                <button type="button" class="add-visual-popup__btn add-visual-popup__btn--primary"
                    [disabled]="!addVisualModalBody.canPerformPrimaryAction" (click)="addVisualModalBody.onPrimaryAction()">
                    {{ addVisualModalBody.primaryActionLabel }}
                </button>
            </div>
        </div>
    </ng-container>
</app-modal>
